import { LazyLoad } from '@petconsole/pure-fe-mui';

const Members = LazyLoad(() => import('./Members'));

export { Members };
